import { render } from "./PostsGrid.vue?vue&type=template&id=395b56d8&ts=true"
import script from "./PostsGrid.vue?vue&type=script&lang=ts"
export * from "./PostsGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__